var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"span12"},[_c('h2',{staticClass:"cv-profile",domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }